"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTraceId = exports.traceIdConstants = void 0;
var guid_typescript_1 = require("guid-typescript");
exports.traceIdConstants = {
    presenceUUID: 'DefaultPresenceUUID'
};
/*
  creating a traceable ID that backend can use to better track
  interactions between Remote Client, Console, and Webcall
*/
function generateTraceId() {
    var availKitTraceId = "AKIT-" + exports.traceIdConstants.presenceUUID;
    var guidComponent = guid_typescript_1.Guid.create().toString();
    return guidComponent + "-" + availKitTraceId;
}
exports.generateTraceId = generateTraceId;
//# sourceMappingURL=generateTraceIds.js.map